<template>
  <div
    class="ui-switcher"
    :class="{ 'ui-switcher_active': value, 'ui-switcher_disabled': disabled }"
    @click="change"
  >
    <svg v-if="!value" width="32" height="22" viewBox="0 0 32 22" fill="none">
      <rect x="0.5" y="0.5" width="31" height="21" rx="10.5" stroke="black" stroke-opacity="0.5"/>
      <circle cx="10" cy="11" r="5" fill="black" fill-opacity="0.5"/>
    </svg>
    <svg v-else width="32" height="22" viewBox="0 0 32 22" fill="none">
      <rect width="32" height="22" rx="11" fill="#ED1651"/>
      <circle cx="22" cy="11" r="5" fill="white"/>
    </svg>
    <div
      v-if="$slots.default"
      class="ui-switcher__text"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'UiSwitcher',

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },

  methods: {
    change() {
      this.$emit('input', !this.value);
    },
  },
};
</script>


<style lang="scss" scoped>
.ui-switcher {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  @media (max-width: 767px) {
    align-items: flex-start;
    svg {
      margin-top: 1px;
    }
  }
  &_disabled {
    pointer-events: none;
  }
  svg {
    flex-shrink: 0;
  }
}
.ui-switcher__text {
  margin-left: 8px;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: #50616F;
  user-select: none;
  @media (max-width: 767px) {
    font-size: 13px;
    line-height: 17px;
  }
}
</style>
